import React, {useState} from 'react';
import SignIn from "./SignIn";
import SignUp from "./SignUp";

const Log = ({signup, signin}) => {
    const [signUpModal, setSignUpModal] = useState(signup);
    const [signInModal, setSignInModal] = useState(signin);

    const handleModals = (e) => {
        if (e.target.id === "register") {
            setSignInModal(false);
            setSignUpModal(true);
        } else if (e.target.id === "login") {
            setSignUpModal(false);
            setSignInModal(true);
        }
    };


    return (
        <div
            className="relative hover:shadow-md p-8 border-blue-300 rounded-3xl bg-blue-50 mt-10 mb-10 md:w-auto flex-1 mx-6 md:mx-32 lg:mx-44 xl:mx-56 ">
            <ul className="h-16 grid grid-cols-2 gap-4">
                <button
                    className={signUpModal ? "bg-red-300 cursor-pointer text-center rounded-2xl" : "bg-red-50 hover:bg-red-300 cursor-pointer text-center rounded-2xl"}
                    onClick={handleModals}
                    id="register"
                >
                    S'inscrire
                </button>
                <button
                    className={signInModal ? "bg-red-300 cursor-pointer text-center rounded-2xl" : "bg-red-50 hover:bg-red-300 cursor-pointer text-center rounded-2xl"}
                    onClick={handleModals}
                    id="login"
                >
                    Se connecter
                </button>
            </ul>
            {signUpModal && <SignUp/>}
            {signInModal && <SignIn/>}
        </div>
    );
};

export default Log;